import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { BrowserRouter } from "react-router";
import "../public/assets/scss/index.scss";
import Router from "./Router";
import { initGA } from "./utils/analytics";
import AppInitializer from "./AppInitializer";
import ScrollToTop from "@/components/common/ScrollTop";
import ScrollTopBehaviour from "./components/common/ScrollTopBehaviour";
import GlobalOtpModal from "./components/globalOtpModal/GlobalOtpModal";
import { HelmetProvider } from "react-helmet-async";
import CookieConsentManager from "./components/cookie/CookieConsentManager";
import GoogleAuthWrapper from "@/components/common/GoogleAuthWrapper.jsx";
import AnalyticsWrapper from "./components/common/AnalyticsWrapper";
// Conditionally import Bootstrap only in browser environment
if (typeof window !== "undefined") {
  import("bootstrap");
}

function App() {
  useEffect(() => {
    initGA();
  }, []);

  return (
    <>
      {/* BrowserRouter for handling routing in the application */}
      <HelmetProvider>
        <BrowserRouter>
          <CookieConsentManager>
            <AnalyticsWrapper>
              <GoogleAuthWrapper>
                <AppInitializer />
                <Router />
                <GlobalOtpModal />
              </GoogleAuthWrapper>
              <ScrollToTop />
              <ScrollTopBehaviour />
              <ToastContainer
                className="toast-position"
                position="top-right"
                autoClose={3000}
                hideProgressBar
              />
            </AnalyticsWrapper>
          </CookieConsentManager>
        </BrowserRouter>
      </HelmetProvider>
    </>
  );
}

// Export the App component as the default export
export default App;
